module.exports = __webpack_public_path__ + "imgs/share-qq@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/share-qq@2x.png
// module id = 228
// module chunks = 93